export default __webpack_public_path__ + "static/media/politicaSicurezza-rev04-2025-01-20.951098f8.pdf";